export enum DateiTyp {
  WINDDATEN_CSV = 2,
  VDI_AUSZUG_PDF = 3,
}
